// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.smiles-container-dropdownToggle {
  background: none;
  border: none;
  box-shadow: none;
  text-transform: none;
  padding: 5px 0px 0px 0px;
}

.smiles-container-dropdownToggle:hover {
  background: none;
  border: none;
  box-shadow: none;
}

.smiles-container-dropdownToggle:focus {
  background: none;
  border: none;
  box-shadow: none;
}

.dropdown-menu {
  outline: none;
}

.smiles-container {
  position: relative;
  bottom: 0;
  right: 3rem;
}

.smiles-button {
  color: rgba(0, 0, 0, 0.87);
  cursor: pointer;
  font-size: 2.2rem !important;
  opacity: 0.7 !important;
}

.smiles-button:hover {
    opacity: 1 !important;
}

.emoji-mart-search {
  display: none;
}

.emoji-mart-anchors {
  background-color: white;
}

.emoji-mart-anchor:focus {
  background-color: white;
}

.emoji-mart-preview {
  height: 5px !important;
  background-color: #c1c1c1;
}

.emoji-mart-preview-emoji {
  display: none;
}

.emoji-mart-preview-skins {
  display: none;
}

.smiles-container-dropdownToggle + .dropdown-menu {
  z-index: 10;
}`, "",{"version":3,"sources":["webpack://./src/app/chat/emoji-dialog/EmojiDialog.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb","sourcesContent":[".smiles-container-dropdownToggle {\r\n  background: none;\r\n  border: none;\r\n  box-shadow: none;\r\n  text-transform: none;\r\n  padding: 5px 0px 0px 0px;\r\n}\r\n\r\n.smiles-container-dropdownToggle:hover {\r\n  background: none;\r\n  border: none;\r\n  box-shadow: none;\r\n}\r\n\r\n.smiles-container-dropdownToggle:focus {\r\n  background: none;\r\n  border: none;\r\n  box-shadow: none;\r\n}\r\n\r\n.dropdown-menu {\r\n  outline: none;\r\n}\r\n\r\n.smiles-container {\r\n  position: relative;\r\n  bottom: 0;\r\n  right: 3rem;\r\n}\r\n\r\n.smiles-button {\r\n  color: rgba(0, 0, 0, 0.87);\r\n  cursor: pointer;\r\n  font-size: 2.2rem !important;\r\n  opacity: 0.7 !important;\r\n}\r\n\r\n.smiles-button:hover {\r\n    opacity: 1 !important;\r\n}\r\n\r\n.emoji-mart-search {\r\n  display: none;\r\n}\r\n\r\n.emoji-mart-anchors {\r\n  background-color: white;\r\n}\r\n\r\n.emoji-mart-anchor:focus {\r\n  background-color: white;\r\n}\r\n\r\n.emoji-mart-preview {\r\n  height: 5px !important;\r\n  background-color: #c1c1c1;\r\n}\r\n\r\n.emoji-mart-preview-emoji {\r\n  display: none;\r\n}\r\n\r\n.emoji-mart-preview-skins {\r\n  display: none;\r\n}\r\n\r\n.smiles-container-dropdownToggle + .dropdown-menu {\r\n  z-index: 10;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
